import React, { useEffect, useMemo, useState } from "react";
import Select, { StylesConfig } from "react-select";
import { useShoppingCart } from "../../../../_default/context/ShoppingCartContext";
import { DefaultReactSelectStyle } from "../../../ReactSelectStyle/ReactSelectStyle";
import { updateStructureComponent } from "../../../../../store/reducers/builderReducers/structure/structureActions";
import { useAppSelector } from "../../../../../store/hooks";
import { SingleProductComponent } from "../../../../_default/interfaces/base";
import { getCatalogProductDisplayFields } from "../../../../_default/utilities/catalogProductAdapter";
import usePageLanguage from "../../../../_default/hooks/usePageLanguage";

export const TextEditorSelectStyle: StylesConfig<any, false> = {
  ...DefaultReactSelectStyle,
  menuList: (styles, data) => {
    return {
      ...styles,
      overflowX: "hidden",
    };
  },
  container: (styles, data) => {
    return {
      ...styles,
    };
  },
  singleValue: (styles, data) => {
    return {
      ...DefaultReactSelectStyle.singleValue!(styles, data),
      overflow: "visible",
      color: "white",
      padding: "0px 5px",
    };
  },
  option: (styles, data) => {
    return {
      ...DefaultReactSelectStyle.option!(styles, data),
      padding: "1px 7px",
      textAlign: "left",
    };
  },
  control: (styles, data) => {
    return {
      ...DefaultReactSelectStyle.control!(styles, data),
      minHeight: "inherit",
      flexWrap: "nowrap",
    };
  },
  valueContainer: (styles, data) => {
    return {
      ...styles,
      padding: "0px",
      minWidth: "inherit",
      alignSelf: "flex-start",
      overflow: "hidden",
      color: "white",
    };
  },

  input: (styles) => {
    return {
      ...styles,
      color: "white",
    };
  },

  menu: (styles, data) => {
    return {
      ...DefaultReactSelectStyle.menu!(styles, data),
      marginTop: "2px",
    };
  },
  dropdownIndicator: (styles, data) => {
    return {
      ...styles,
      height: "100%",
      padding: 0,
      alignSelf: "flex-start",
      alignItems: "center",
      width: "12px",
      color: "#fff",
      svg: {
        height: "12px",
      },
    };
  },
};

export default function SingleProductMenu({ id, triggerResize }: any) {
  const component = useAppSelector(
    (state) => state.builder.structure.components[id] as SingleProductComponent
  );
  const { listableCatalogProducts } = useShoppingCart();
  const lang = usePageLanguage();
  const [searchQuery, setSearchQuery] = useState("");

  const productOptions = useMemo(
    () =>
      listableCatalogProducts
        .map((product) => ({
          value: product.productUuid,
          label: getCatalogProductDisplayFields(product, lang).displayName || "",
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [listableCatalogProducts, lang]
  );

  useEffect(() => {
    const uuid =
      (component.attributes as { productUuid?: string }).productUuid ??
      undefined;
    if (uuid) {
      const found = productOptions.find((x) => x.value === uuid);
      if (found) {
        setSearchQuery(found.label);
      }
    }
  }, [component.attributes, productOptions]);

  return (
    <div className="border-menu_input">
      <Select
        menuPosition="fixed"
        isSearchable={true}
        styles={TextEditorSelectStyle}
        noOptionsMessage={({}) => ""}
        value={productOptions.find((x) => x.label === searchQuery)}
        onChange={(val) => {
          if (!val) {
            return;
          }
          setSearchQuery(val.label);
          updateStructureComponent(id, "attributes.productUuid", val.value);
        }}
        options={productOptions}
        placeholder="Search product by name"
      ></Select>
    </div>
  );
}
